import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionProps, selectState } from '../../utils/reduxActions';
import { appActions } from '../../commons/reducer';
import { invoicesActions } from '../../views/Invoices/reducer';
interface DashboardProps {
  actions?: any;
  profile?: any;
  invoicingReport?: any;
  history?: any;
}

const Dashboard: React.FC<DashboardProps> = (props) => {
  const { profile, invoicingReport, actions } = props

  useEffect(() => {
    actions.getInvoicingReport();
  }, [actions]);

  // State to track expanded/collapsed sections
  const [expandedPaymentForms, setExpandedPaymentForms] = useState<string[]>([])
  const [expandedCarriers, setExpandedCarriers] = useState<string[]>([])
  const [expandedInvoices, setExpandedInvoices] = useState<string[]>([])
  
  // Toggle functions
  const togglePaymentForm = (paymentForm: string) => {
    setExpandedPaymentForms(prev => 
      prev.includes(paymentForm) 
        ? prev.filter(item => item !== paymentForm)
        : [...prev, paymentForm]
    )
  }

  const toggleCarrier = (carrierId: string) => {
    setExpandedCarriers(prev => 
      prev.includes(carrierId) 
        ? prev.filter(item => item !== carrierId)
        : [...prev, carrierId]
    )
  }

  const toggleInvoice = (invoiceId: string) => {
    setExpandedInvoices(prev => 
      prev.includes(invoiceId) 
        ? prev.filter(item => item !== invoiceId)
        : [...prev, invoiceId]
    )
  }

  return (
    <div className="text-blueGray-700 antialiased">

      <div className="relative md:ml-42 bg-blueGray-50">
        <div className="relative bg-primary-inabit-red md:pt-32 pb-8 pt-12 rounded-xl shadow-xl">
          <div className="px-4 md:px-10 mx-auto w-full">
            <div>
              <div className="grid grid-cols-1 lg:grid-cols-4">
                <div className="grid px-4">
                  <div className="relative flex flex-col min-w-0 break-words bg-white rounded-xl mb-6 xl:mb-0 shadow-xl">
                    <div className="flex-auto p-4">
                      <div className="flex flex-wrap">
                        <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
                          <h5 className="text-blueGray-400 uppercase font-bold text-xl">
                            Créditos disponibles
                          </h5>
                          <span className="font-semibold text-3xl text-blueGray-700">
                            $ {profile.credits?.toFixed(2) || 0} MXN
                          </span>
                        </div>
                        <div className="relative w-auto pl-4 flex-initial">
                          <div className="text-white p-4 text-center inline-flex items-center justify-center w-14 h-14 shadow-lg rounded-full bg-red-500 text-xl">
                            <i className="fas fa-dollar-sign"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid px-4">
                  <div
                    className="relative flex flex-col min-w-0 break-words bg-white rounded-xl mb-6 xl:mb-0 shadow-xl"
                  >
                    <div className="flex-auto p-4">
                      <div className="flex flex-wrap">
                        <div
                          className="relative w-full pr-4 max-w-full flex-grow flex-1"
                        >
                          <h5 className="text-blueGray-400 uppercase font-bold text-xl">
                            Guías generadas
                          </h5>
                          <span className="font-semibold text-3xl text-blueGray-700">
                            {profile.totalOfShippings || 0}
                          </span>
                        </div>
                        <div className="relative w-auto pl-4 flex-initial">
                          <div className="text-white p-4 text-center inline-flex items-center justify-center w-14 h-14 shadow-lg rounded-full bg-red-500 text-xl">
                            <i className="fas fa-bus"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Invoicing report */}
          <div className="py-6 px-10 md:px-10 mx-auto w-full">
            <div className="grid grid-cols-1 lg:grid-cols-3 px-4 items-start">
              {invoicingReport?.data?.map((company: any) => (
                <div key={company.company} className="mr-4 relative flex flex-col min-w-0 break-words bg-white rounded-xl mb-6 xl:mb-0 shadow-xl">
                  <h2 className="p-2 text-2xl rounded-t-xl font-bold text-blueGray-700 bg-primary-inabit-blue text-white">Facturación ({company.company}):</h2>
                  {company.data.map((item: any) => (
                    <div key={item.paymentForm} className="px-4 mb-2">
                      <div 
                        className="text-blueGray-300 uppercase text-lg flex justify-between items-center cursor-pointer py-2 hover:bg-gray-50 rounded"
                        onClick={() => togglePaymentForm(`${company.company}-${item.paymentForm}`)}
                      >
                        <div className="flex items-center">
                          <span className="mr-2">
                            {expandedPaymentForms.includes(`${company.company}-${item.paymentForm}`) ? '▼' : '►'}
                          </span>
                          <span className="text-blueGray-300 font-bold">{item.paymentForm}</span>
                        </div>
                        <span className="text-blueGray-700 font-bold">{item.carriers.reduce((acc: number, carrier: any) => acc + carrier.invoices.reduce((acc: number, invoice: any) => acc + invoice.Total, 0), 0)}</span>
                      </div>

                      {expandedPaymentForms.includes(`${company.company}-${item.paymentForm}`) && item.carriers.map((carrier: any) => {
                        const carrierId = `${company.company}-${item.paymentForm}-${carrier.serviceName}`;
                        return (
                          <div key={carrierId} className="pl-4">
                            <div 
                              className="text-blueGray-300 uppercase text-lg flex justify-between items-center cursor-pointer hover:bg-gray-50 rounded"
                              onClick={() => toggleCarrier(carrierId)}
                            >
                              <div className="flex items-center">
                                <span className="mr-2">
                                  {expandedCarriers.includes(carrierId) ? '▼' : '►'}
                                </span>
                                <span className="text-blueGray-300">{carrier.serviceName}</span>
                              </div>
                              <span className="text-blueGray-700">{carrier.invoices.reduce((acc: number, invoice: any) => acc + invoice.Total, 0)}</span>
                            </div>
                            
                            {expandedCarriers.includes(carrierId) && carrier.invoices.map((invoice: any) => {
                              const invoiceId = `${carrierId}-${invoice.Id}`;
                              return (
                                <div key={invoiceId} className="pl-6">
                                  <div 
                                    className="text-blueGray-400 uppercase text-lg flex justify-between items-center cursor-pointer py-2 hover:bg-gray-50 rounded"
                                    onClick={() => toggleInvoice(invoiceId)}
                                  >
                                    <div className="flex items-center">
                                      <span className="mr-2">
                                        {expandedInvoices.includes(invoiceId) ? '▼' : '►'}
                                      </span>
                                      <span className="text-blueGray-300">{invoice.Id}</span>
                                    </div>
                                    <span className="text-blueGray-700">{invoice.shippings.reduce((acc: number, shipping: any) => acc + shipping.total, 0)}</span>
                                  </div>
                                  
                                  {expandedInvoices.includes(invoiceId) && invoice.shippings.map((shipping: any) => (
                                    <div key={shipping.trackingNumber} className="pl-8">
                                      <div className="text-blueGray-400 uppercase text-lg flex justify-between py-2">
                                        <span className="text-blueGray-300">{shipping.trackingNumber}</span>
                                        <span className="text-blueGray-700">{shipping.total}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const withConnect = connect(
  selectState(
    'app.profile',
    'invoicesList.invoicingReport',
  ),
  actionProps({ ...appActions, ...invoicesActions }),
);

export default withRouter(withConnect(Dashboard));
